import React from 'react';
import Icon, { IconPropsOnIconWrapper } from '../Icon';

const Icon360 = (props: IconPropsOnIconWrapper): JSX.Element => <Icon {...props} name='icon-web-32-360-full' />;

export default Icon360;
